const de = {
  title: 'Kalender',
  settings: 'Einstellungen',
  openFailed: 'Die Termine konnten nicht geladen werden',
  detail: {
    openFailed: 'Das Event konnte nicht geöffnet werden',
    notFound: 'Das Event wurde nicht gefunden'
  },
  type: {
    general: 'Allgemein',
    study: 'Studium',
    event: 'Veranstaltung',
    legal: 'Rechtliches',
    holiday: 'Freier Tag'
  },
  calendar_props: {
    date: 'Datum',
    time: 'Zeit',
    event: 'Event',
    allDay: 'Ganztägig',
    week: 'Woche',
    day: 'Tag',
    month: 'Monat',
    previous: 'Zurück',
    next: 'Nächstes',
    yesterday: 'Gestern',
    tomorrow: 'Morgen',
    today: 'Heute',
    agenda: 'Agenda',
    noEventsInRange: 'Keine Events auf dieser Seite.',
    showMore: 'mehr'
  }
};

export default de;
export type CalendarTranslation = typeof de;
